module.exports = __webpack_public_path__ + "static/media/shave.b7bf24b8.svg";